import React from 'react'
import { Link } from 'gatsby'
import './Text.scss'

const RelatedArticles = ({related}) => {
	if(related) {
		return(
			<aside className="RelatedArticles">
				<p className="title">Relaterte historier</p>
				<ul>
					{
						related.edges.map(item => <li key={item.node.id}><Link to={item.node.uri}>{item.node.title}</Link></li>)
					}
				</ul>
			</aside>
		)
	}
	return null
}

const Text = ({text, id, related}) => {
	return(
		<div className="CaseContent-Text">
			<div className="grid">
				<div className="CaseContent-Text-wrapper" dangerouslySetInnerHTML={{__html: text}} />
				{ id === 0 && <RelatedArticles related={related} /> }
			</div>
		</div>
	)
}

export default Text